import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import { TableDataCell } from "@digital-services/ui";
import { CopyToClipboard } from "@ds-cps/ui";

import { ResourceMetadataKeys, ResourceSummaryModel } from "@resource/models";

import { formatterShort } from "@utils/time-utils";

import { OwnerCellContentWithTooltip } from "./OwnerCellContentWithTooltip";
import { RelationshipTypeCellContent } from "./RelationshipTypeCellContent";

interface Props {
  data: ResourceSummaryModel;
  onRowClick: () => void;
}

export const ResourcesTableDataRow: FC<Props> = props => {
  const { data, onRowClick } = props;
  const { metadata, relationships } = data;

  const { organizationId } = useParams();

  const { t: tCommon } = useTranslation(undefined, {
    keyPrefix: "common"
  });

  const productFamilyName = metadata.find(
    e => e.key === ResourceMetadataKeys.ProductFamilyName
  );

  return (
    <tr
      key={`table-row-${data.id}`}
      data-testid={`table-row-${data.id}`}
      className="cursor-pointer [&:hover_td:first-child_div]:block"
      onClick={onRowClick}
    >
      <TableDataCell className="group">
        {data.serialNumber}
        <span className="invisible ml-1 group-hover:visible">
          <CopyToClipboard
            value={data.serialNumber}
            message={tCommon("copied-to-clipboard", {
              entityName: "Serial Number"
            })}
          />
        </span>
      </TableDataCell>
      <TableDataCell>{data.resourceType}</TableDataCell>
      <TableDataCell className="max-w-[100px]">
        {productFamilyName ? productFamilyName.value : ""}
      </TableDataCell>
      <TableDataCell className="max-w-[200px]">
        {organizationId ? (
          <RelationshipTypeCellContent
            relationships={relationships}
            organizationId={organizationId}
          />
        ) : (
          <OwnerCellContentWithTooltip relationships={relationships} />
        )}
      </TableDataCell>
      <TableDataCell>{formatterShort(data.createdOn)}</TableDataCell>
    </tr>
  );
};
